import React, { PureComponent } from 'react';

import { CustomerFormValuesType } from 'Type/Account.type';

import MyAccountSubscriptionFields from './MyAccountSubscriptionFields.component';

/** @namespace PeggysagePwa/Component/MyAccountSubscriptionFields/Container */
export class MyAccountSubscriptionFieldsContainer extends PureComponent {
    static propTypes = {
        defaultValues: CustomerFormValuesType
    };

    static defaultProps = {
        defaultValues: {}
    };

    containerFunctions = {
        // getData: this.getData.bind(this)
    };

    containerProps() {
        const { defaultValues } = this.props;

        return {
            defaultValues
        };
    }

    render() {
        return (
            <MyAccountSubscriptionFields
              { ...this.containerFunctions }
              { ...this.containerProps() }
            />
        );
    }
}

export default MyAccountSubscriptionFieldsContainer;
